import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@fi-app/components/components.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { AreaViewComponent } from './area-view/area-view.component';
import { AreaService } from './area.service';
import { AreaEditComponent } from './area-edit/area-edit.component';
import { AreaListComponent } from './area-list/area-list.component';
import { AreaDeleteModule } from './area-delete/area-delete.module';
import { AreaSelectParentAreaRightsComponent } from './area-select-parent-area-rights/area-select-parent-area-rights.component';
import { AreaViewContainerComponent } from './area-view-container/area-view-container.component';
import { UIRouterModule } from '@uirouter/angular';
import { FiAreaStates } from './area-states';
import { MatTabsModule } from '@angular/material/tabs';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatCardModule } from '@angular/material/card';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FiAreaListWrapperTableComponent } from '@fi-app/area/area-list/area-list-wrapper-table/area-list-wrapper-table.component';
import { BusinessUnitModule } from '@fi-app/business-unit/business-unit.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        FormsModule,
        ComponentsModule,
        AreaDeleteModule,
        UIRouterModule.forChild(FiAreaStates),
        MatTabsModule,
        FiPageHeaderButtonGroupModule,
        FiPageHeaderModule,
        MatCardModule,
        SelectSearchModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
        BusinessUnitModule,
    ],
    declarations: [
        AreaViewComponent,
        AreaEditComponent,
        AreaListComponent,
        AreaSelectParentAreaRightsComponent,
        AreaViewContainerComponent,
        FiAreaListWrapperTableComponent,
    ],
    providers: [AreaService],
})
export class AreaModule {}
